import { create } from "zustand";
import type { TAnalyticsData, TSessionAnalytics } from "@/types/TAnalytics";
import { getAnalytics, getSessionAnalytics } from "@/services/analytics/getAnalytics";

type AnalyticsState = {
  data: TAnalyticsData | null;
  sessionData: TSessionAnalytics | null;
  isLoading: boolean;
  error: string | null;
  selectedDays: number;
  
  fetchAnalytics: (days?: number) => Promise<void>;
  setSelectedDays: (days: number) => void;
  reset: () => void;
};

const initialState = {
  data: null,
  sessionData: null,
  isLoading: false,
  error: null,
  selectedDays: 30,
};

export const useAnalyticsStore = create<AnalyticsState>((set, get) => ({
  ...initialState,

  fetchAnalytics: async (days?: number) => {
    const daysToFetch = days ?? get().selectedDays;
    set({ isLoading: true, error: null });
    
    try {
      const [data, sessionData] = await Promise.all([
        getAnalytics(daysToFetch),
        getSessionAnalytics(daysToFetch).catch(() => null),
      ]);
      set({ data, sessionData, isLoading: false, selectedDays: daysToFetch });
    } catch (error) {
      console.error("Error fetching analytics:", error);
      set({ 
        error: error instanceof Error ? error.message : "Fehler beim Laden der Analytics",
        isLoading: false 
      });
    }
  },

  setSelectedDays: (days: number) => {
    set({ selectedDays: days });
    get().fetchAnalytics(days);
  },

  reset: () => set(initialState),
}));
